const publicConfig = process.env.PUBLIC_CONFIG;
const nvBuildsModule = angular.module('nv.builds', []).name;

// The app's revision number is stored in a meta tag in the head
const metaRevision = document.querySelector('meta[name=revision]');
const revision = (metaRevision && metaRevision.content) || 'unknown';

// Run time changes to public config
if (process && process.env && process.env.DISABLE_STATIC_BUNDLES) {
  console.warn('STATIC BUNDLES disabled');
  publicConfig.STATIC_BUNDLES = false;
}

angular
  .module(nvBuildsModule)
  .constant('PublicConfig', publicConfig)
  .constant('ROLLBAR_BASE_CONFIG', {
    accessToken: publicConfig.ROLLBAR_POST_CLIENT_ITEM,
    autoInstrument: {
      network: true,
      log: true,
      dom: true,
      navigation: true,
      connectivity: false,
    },
    // setting `captureUncaught: true` will allow all uncaught errors to be sent to Rollbar,
    // including those generated by vendor code. May temporarily pass through more errors to Rollbar
    // but will being handling in checkIgnore as err sources are identified.
    captureUncaught: true,
    verbose: true,
    //if true, logs errs from failed promises that don't have a .then() handler
    captureUnhandledRejections: false,
    // add error messages we want to ignore - such as those generated by 3rd party packages
    ignoredMessages: [],
    /**
     * Custom matcher.  At present time, only checks for a couple auth0 vendor errors, to prevent these from being
     * reported to Rollbar.
     *
     * @param isUncaught
     * @param args
     * @param payload
     * @returns {boolean}
     */
    checkIgnore: (isUncaught, args, payload) => {
      const { request, body } = payload;
      const isLoginUrl = _.includes(request.url, '/login');
      const auth0Errors = ['server error', 'User closed the popup window'];

      // for now, only handling specific auth0 vendor errs.
      if (isLoginUrl) {
        // and only handling if there's a stack trace
        if (body.trace && body.trace.exception.message) {
          const isIgnorable = auth0Errors.indexOf(body.trace.exception.message) > -1;
          if (isIgnorable) return true;
        }
      }
    },
    payload: {
      client: {
        javascript: {
          source_map_enabled: true,
          guess_uncaught_frames: true,
          code_version: revision,
        },
      },
      environment: publicConfig.ROLLBAR_ENV,
      server: {
        root: 'webpack:///.',
      },
      person: {
        id: undefined,
        username: undefined,
        email: undefined,
      },
      nv_authorizationStatus: undefined,
      // school
      nv_role: undefined,
      nv_delegatedRole: undefined,
      // shelter
      nv_roleShelter: undefined,
      nv_delegatedRoleShelter: undefined,
    },
  });

export default nvBuildsModule;
